export default {
  darkOrange: '#e86a1a',
  lightOrange: '#e86b24',
  white: '#ffffff',
  lightGray: '#9b9b9b',
  articleBorderGray: '#d8d8d8',
  superLightGray: '#fafafa',
  superLightGray2: '#f2f2f2',
  gray: '#4a4a4a',
  darkRed: '#d0021b',
  borderGray: '#d8d8d8',
  // yellow: '#eada1b,
  warningYellow: '#f5a623',
  darkYellow: '#ecdf38',
  tagLightBlue: '#f2f9fc',
  tagBlue: '#4a90e2',
  tagBorderBlue: '#cae6f3',
  black: '#000000',
  lineGray: '#d0d0d0',
  lineGray2: '#ededed',
  bgGray: '#ebebeb',
  inputLabel: '#4a4a4a',
  inputBorder: '#8e8e8e',
  ticketBorder: '#e8e8e8',
  cyan: '#00cfa7',
  yellow: '#f8e71c',
  cautionYellow: '#ffe96b',
  borderButtonGray: '#979797',
  green: '#00af8d',
  darkGreen: '#0b6416',
  superLightBlue: '#f2f9fc',
  lightBlue: '#cae6f3',
  blue: '#1cb6e6',
  darkBlue: '#4a90e2',
  darkBlueTwo: '#425e6c',
  red: '#d0021b',
  blueGray: '#e2ecf0',
  blueGrayLight: '#f0f5f7',
  web5Dark: '#2b3940',
};
